import messagesJa from './ja/messages.ja'
import messagesEn from './en/messages.en'

export default {
  ja: messagesJa,
  en: messagesEn,
}
